/**
 * Agreement Types
 */
enum AgreementTypeEnum {
	LandownerAgreement = 1, 
	LeaseAgreement = 2, 
}

// tslint:disable-next-line: no-default-export
export default AgreementTypeEnum;
